import AsyncStorage from '@react-native-async-storage/async-storage';
import * as Device from 'expo-device';
import { uid } from './date';

// Identificação deste aparelho (para saber qual celular sincroniza com a agenda do Google).
let cache: string | null = null;
export async function idAparelho() {
  if (cache) return cache;
  let id = await AsyncStorage.getItem('mp_aparelho').catch(() => null);
  if (!id) { id = uid(); await AsyncStorage.setItem('mp_aparelho', id).catch(() => {}); }
  cache = id;
  return id;
}
export const nomeAparelho = () => [Device.manufacturer, Device.modelName].filter(Boolean).join(' ') || 'Celular';
